import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BrokersStore } from '../stores/brokersStore';

export const useBrokersStore = () => useContext<{
  brokersStore: BrokersStore
}>(StoreContext);
